// SearchFilterRow.js
// DEPRECATED — use DataToolbar from './DataToolbar'.
// Mantido como re-export wrapper para zero quebra dos 5+ consumers existentes
// (MainContainer.renderSearch + páginas que importam direto).
//
// Migração: trocar import e ajustar API:
//   search:        { value, onChange, onClear, onVoice, placeholder, autoFocus }
//   filters:       [{ id, options, value, onChange, label, getOptionLabel }]
//   filterButton:  { onClick, count, label }
//   extraActions:  ReactNode
//
// Anterior aceitava searchValue/onSearchChange/filterOptions/etc soltos —
// abaixo mapeia esse contrato antigo para a nova API DataToolbar.

import React from 'react'
import DataToolbar from './DataToolbar'

export default function SearchFilterRow({
  searchValue, onSearchChange, onSearchClear, onVoiceClick,
  searchPlaceholder, searchAutoFocus,
  filterOptions, filterValue, onFilterChange, filterLabel, filterGetOptionLabel,
  onFilterButtonClick, filterButtonLabel,
  preChildren, extraSlot, alertSlot,
  sx,
}) {
  const search = onSearchChange !== undefined ? {
    value: searchValue,
    onChange: onSearchChange,
    onClear: onSearchClear,
    onVoice: onVoiceClick,
    placeholder: searchPlaceholder,
    autoFocus: searchAutoFocus,
  } : undefined

  const filters = filterOptions !== undefined ? [{
    id: 'filter',
    options: filterOptions,
    value: filterValue,
    onChange: onFilterChange,
    label: filterLabel,
    getOptionLabel: filterGetOptionLabel,
  }] : []

  const filterButton = onFilterButtonClick ? {
    onClick: onFilterButtonClick,
    label: filterButtonLabel,
  } : undefined

  return (
    <DataToolbar
      search={search}
      filters={filters}
      filterButton={filterButton}
      extraActions={extraSlot}
      preChildren={preChildren}
      alertSlot={alertSlot}
      sx={sx}
    />
  )
}
